<div class="chat-rule-dialog">
  <div class="dialog-header">
    <span>Chat rules</span>
    <i class="fi-x" (click)="handleCloseChatRule()"></i>
  </div>
  <div class="dialog-wrap">
    <div class="container" *ngFor="let rule of ruleList">
      <h3>{{ rule.title }}</h3>
      <ul>
        <li *ngFor="let item of rule.content">
          <p>{{ item }}</p>
        </li>
      </ul>
    </div>
  </div>
  <div class="dialog-btn">
    <cs-button class="close-btn" [height]="'48px'" [size]="'large'" [label]="'Close'" (click)="handleCloseChatRule()" />
  </div>
</div>
